export default "__VITE_ASSET__5aed4e56__"